import services from '@/services/ascentiaServiceIndex'
import { USER_GUIDE_CONSTS as UGC } from '../consts'

const state = {
  userGuides: [],
  userGuidesLoading: false,
  userContentsLoading: false,
  userContents: [],
}

const getters = {
  helpAboutContents: state => {
    return state.userContents.filter(content => {
      return content.typeId === 1 || content.typeId === 2
    })
  },
}

const mutations = {
  [UGC.UPDATE_ALL_USER_GUIDES]: (state, data) => (state.userGuides = data),
  [UGC.UPDATE_USER_GUIDES_LOADING]: (state, data) =>
    (state.userGuidesLoading = data),
  [UGC.UPDATE_USER_CONTENTS_LOADING]: (state, data) =>
    (state.userContentsLoading = data),
  [UGC.UPDATE_USER_CONTENTS]: (state, data) => (state.userContents = data),
  [UGC.UPDATE_USER_CONTENT]: (state, data) => {
    state.userContents = state.userContents.map(content => {
      if (content.typeId === data.typeId) {
        return { ...content, ...data }
      } else return content
    })
  },
  [UGC.UPDATING_CONTENT]: (state, data) => {
    state.userContents = state.userContents.map(content => {
      if (content.typeId === data.typeId) {
        return { ...content, ...{ saving: data.saving } }
      } else return content
    })
  },
}

const actions = {
  async [UGC.GET_ALL_USER_GUIDES]({ commit }, args = { refresh: false }) {
    commit(UGC.UPDATE_USER_GUIDES_LOADING, true)
    try {
      const response = await services.userGuide.getData(
        'allUserGuides',
        null,
        args.refresh,
      )

      commit(UGC.UPDATE_ALL_USER_GUIDES, response.data)
      commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
    } catch (error) {
      console.log(UGC.GET_ALL_USER_GUIDES + ': error ' + error)
      commit(UGC.UPDATE_ALL_USER_GUIDES, [])
      commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
    }
  },

  // eslint-disable-next-line no-unused-vars
  async [UGC.GET_USER_GUIDE_BY_ID]({ commit }, userGuideId) {
    try {
      const response = await services.userGuide.getData(
        'userGuideById',
        userGuideId,
        true,
      )

      if (response.status === 200) {
        const url = window.URL.createObjectURL(
          new Blob([response.data], { type: 'application/pdf' }),
        )
        return url
      }
      return null
    } catch (error) {
      console.log(`${UGC.GET_USER_GUIDE_BY_ID} error: ${error}`)
    }
  },

  async [UGC.SAVE_USER_GUIDE]({ commit, dispatch }, userGuide) {
    commit(UGC.UPDATE_USER_GUIDES_LOADING, true)
    try {
      const userGuideResponse = await services.userGuide.saveData(
        'userGuide',
        userGuide,
      )

      if (userGuideResponse.status === 200) {
        commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
        dispatch(UGC.GET_ALL_USER_GUIDES, { refresh: true })
      }
    } catch (error) {
      commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
      console.log(`${UGC.SAVE_USER_GUIDE} error: ${error}`)
    }
  },

  async [UGC.UPDATE_USER_GUIDE]({ commit, dispatch }, userGuide) {
    commit(UGC.UPDATE_USER_GUIDES_LOADING, true)
    try {
      const userGuideResponse = await services.userGuide.saveData(
        'userGuide',
        userGuide,
      )

      if (userGuideResponse.status === 200) {
        commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
        dispatch(UGC.GET_ALL_USER_GUIDES, { refresh: true })
      }
    } catch (error) {
      commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
      console.log(`${UGC.userGuide.userGuide} error: ${error}`)
    }
  },

  async [UGC.DELETE_USER_GUIDE]({ commit, dispatch }, userGuideIDs) {
    commit(UGC.UPDATE_USER_GUIDES_LOADING, true)
    await Promise.all([
      await services.userGuide.deleteData('userGuide', userGuideIDs),
    ])
      .then(responses => {
        responses.flat().forEach(response => {
          if (response && response.status && response.status === 200) {
            // user guide succefully deleted
            commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
            dispatch(UGC.GET_ALL_USER_GUIDES, { refresh: true })
          }

          return response
        })
      })
      .catch(error => {
        console.error(UGC.DELETE_USER_GUIDE + ': error ' + error)
        commit(UGC.UPDATE_USER_GUIDES_LOADING, false)
      })
  },

  // eslint-disable-next-line no-unused-vars
  async [UGC.USER_GUIDE_DOWNLOAD]({ commit }, type) {
    try {
      await services.userGuide.getData('userGuideDownload', type)
    } catch (err) {
      return err
    }
  },
  async [UGC.GET_PDF_USER_GUIDE]({ commit }, airlineUser) {
    try {
      const response = await services.blobTransfer.getData(
        'pdf',
        airlineUser,
        true,
      )
      if (response.data) {
        commit(UGC.GET_PDF_USER_GUIDE, response.data)
      }
    } catch (error) {
      console.log(`${UGC.GET_PDF_USER_GUIDE} error: ${error}`)
    }
  },

  // Content
  async [UGC.GET_ALL_USER_CONTENTS]({ commit }) {
    commit(UGC.UPDATE_USER_CONTENTS_LOADING, true)
    try {
      const userContentTypes = await services.userGuide.getData(
        'userContentTypes',
      )

      await services.userGuide
        .getData('allUserContents', userContentTypes)
        .then(contentsResponse => {
          Promise.all(
            contentsResponse.map(
              async (
                { name, id, content, typeId, lastUpdatedOn, updatedById },
                i,
              ) => {
                const userResponse = updatedById
                  ? await services.user.getData('user', updatedById)
                  : null

                const userData =
                  userResponse && userResponse.data
                    ? userResponse.data
                    : {
                        firstName: '',
                        lastName: '',
                        userId: updatedById,
                      }

                contentsResponse[i] = {
                  name,
                  id,
                  content,
                  typeId,
                  lastUpdatedOn,
                  user: {
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    userId: userData.userId,
                  },
                }
              },
            ),
          )
            .then(() => {
              commit(UGC.UPDATE_USER_CONTENTS, contentsResponse)
            })
            .catch(error => {
              console.log(
                `${UGC.GET_ALL_USER_CONTENTS} user details error: ${error}`,
              )
            })
            .finally(() => {
              commit(UGC.UPDATE_USER_CONTENTS_LOADING, false)
            })
        })
    } catch (error) {
      console.log(`${UGC.GET_ALL_USER_CONTENTS} error: ${error}`)
    }
  },

  async [UGC.SAVE_USER_CONTENT]({ commit, dispatch }, userContent) {
    const typeId = userContent.typeId
    try {
      commit(UGC.UPDATING_CONTENT, {
        typeId: typeId,
        saving: true,
      })

      await services.userGuide
        .saveData('userContent', userContent)
        .then(res => {
          if (res instanceof Error) return Promise.reject(res)

          if (res.status === 200) {
            dispatch(UGC.GET_USER_CONTENT_BY_ID, typeId, { refresh: true })
          }
        })
    } catch (error) {
      console.log(`${UGC.SAVE_USER_CONTENT} error: ${error}`)
    } finally {
      commit(UGC.UPDATING_CONTENT, {
        typeId: typeId,
        saving: false,
      })
    }
  },
  async [UGC.GET_USER_CONTENT_BY_ID](
    { commit },
    typeId,
    args = { refresh: false },
  ) {
    try {
      commit(UGC.UPDATING_CONTENT, {
        typeId: typeId,
        saving: true,
      })
      const response = await services.userGuide.getData(
        'userContentById',
        typeId,
        args.refresh,
      )
      commit(UGC.UPDATE_USER_CONTENT, response.data)
    } catch (error) {
      console.log(`${UGC.GET_USER_CONTENT_BY_ID} error: ${error}`)
    } finally {
      commit(UGC.UPDATING_CONTENT, {
        typeId: typeId,
        saving: false,
      })
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
